module.exports = __webpack_public_path__ + "img/chara_line_4.8b0164e8.png";